module.exports = __webpack_public_path__ + "img/boomy-sad.0ac243de.png";